/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/brand.config.json';

export interface IBrandMethods extends IPluginMethodMap {
  getBrandProfile(args: any): Promise<any>;
}

export class BrandService implements IAgentPlugin {
  readonly methods: IBrandMethods;

  constructor() {
    this.methods = {
      getBrandProfile: this.getBrandProfile.bind(this),
    };
  }

  async getBrandProfile(args: any) {
    return {
      ...(config || {}),
    };
  }
}
